import React, {useEffect} from 'react'
import {gaEvent} from 'shared'

export const NoResult = () => {
  useEffect(() => {
    const currentCategory = $('.category-selection').text()
    const currentLocation = $('.location-selection').text()
    const eventDetails = `Category: ${currentCategory} / Location: ${currentLocation}`
    gaEvent('engagement', 'pageload zero_results', eventDetails, null, true)
  }, [])

  return <div className="generic-no-results">
           {I18n.t('discover.categories.index.no_result_hint', {defaultValue: 'N/A'})}
         </div>
}
